import { motion } from 'framer-motion';
import { ShieldCheck, MapPin, FileCheck, Route, Trees, TrendingUp, Handshake, HardHat, Users } from 'lucide-react';
import { WHY_US, COMPANY } from '../../data/site';

const ICONS = { ShieldCheck, MapPin, FileCheck, Route, Trees, TrendingUp, Handshake, HardHat, Users };

export const WhyGrid = ({ dark = false }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px border ${dark ? 'bg-sand/10 border-sand/10' : 'bg-clay border-clay'}`}>
    {WHY_US.map((w, i) => {
      const Icon = ICONS[w.icon];
      return (
        <motion.div
          key={w.num}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
          className={`group p-8 lg:p-10 transition-colors duration-500 ${dark ? 'bg-moss hover:bg-bark' : 'bg-sand hover:bg-stone'}`}
          data-testid={`why-item-${w.num}`}
        >
          <div className="flex items-start justify-between">
            <span className="w-11 h-11 bg-terra/10 text-terra flex items-center justify-center"><Icon size={18} /></span>
            <span className={`font-serif italic text-3xl transition-colors duration-500 ${dark ? 'text-sand/15' : 'text-ink/10'} group-hover:text-terra`}>{w.num}</span>
          </div>
          <h3 className={`mt-6 font-heading font-bold text-lg tracking-tight ${dark ? 'text-sand' : 'text-ink'}`}>{w.title}</h3>
          <p className={`mt-2.5 text-sm leading-relaxed ${dark ? 'text-sand/60' : 'text-ink/60'}`}>{w.desc}</p>
        </motion.div>
      );
    })}
  </div>
);

export const WhyChooseUs = () => (
  <section data-testid="why-choose-us-section" className="py-24 lg:py-32 bg-moss text-sand">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-4">CHAPTER 03 — THE PRAKRUTI WAY</p>
      <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl mb-16">
        Why Choose Us
      </h2>
      <WhyGrid dark />
      <motion.p
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-16 text-center font-serif italic text-2xl sm:text-3xl text-sand/70"
        data-testid="why-tagline"
      >
        “{COMPANY.tagline}”
      </motion.p>
    </div>
  </section>
);
